function empty() {
  return [];
}

export default function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/d3-selection/src/selectorAll.js
// module id = 180
// module chunks = 29 30